export default {
  occupazione(state) {
    return state.occupazione;
  },

  tipologie(state) {
    return state.tipologie;
  },

  trattamenti(state) {
    return state.trattamenti;
  },

  tipiPersona(state) {
    return state.tipiPersona;
  },

  servizi(state) {
    return state.servizi;
  },

  serviziForm(state) {
    return state.serviziForm;
  },

  mezzi(state) {
    return state.mezzi;
  },

  preventivi(state) {
    return state.preventivi;
  },

  orari(state) {
    return state.orari;
  },

  contatti(state) {
    return state.contatti;
  },

  messaggioDefault(state) {
    return state.messaggiDiDefault;
  },

  terminiCancellazione(state) {
    return state.terminiDiCancellazione;
  },
};
